import { holdsPermission } from '@/shared/auth/hooks';
import type { CurrentUser } from '@/shared/api/types';

import type { NavItem } from './types';

/**
 * Whether the user's menu offers `item` (before the item's own `useVisible` hook): administrators see everything; an item with
 * `permissions` is shown to the people who hold one of them; other items of the `admin` section or marked `adminOnly` stay
 * administrators'; the rest is for everyone.
 */
export function isNavItemVisible(
  item: Pick<NavItem, 'permissions' | 'adminOnly' | 'section'>,
  user: Pick<CurrentUser, 'isAdmin' | 'permissions' | 'scopedPermissions'> | null | undefined,
): boolean {
  if (user?.isAdmin) return true;
  if (item.permissions) return holdsPermission(user, item.permissions);
  return !item.adminOnly && item.section !== 'admin';
}
